import {Injectable} from '@angular/core';
import {CheckListStrategy} from './check-list.strategy';
import {Checkpoint} from '../../../data/checkpoint.model';
import {CheckpointType} from '../../../data/checkpoint-type.enum';


@Injectable()
export class AnalyseCheckListStrategy implements CheckListStrategy {

  availableTypes: CheckpointType[] = [CheckpointType.Development, CheckpointType.Test];
  stage = undefined;
  getDefaultValue(): Partial<Checkpoint> {
    return {
      type: CheckpointType.Development
    };
  }
}
